export interface IAuthority {
    name: string;
    description?: string;
    groupId?: number;
}

export class Authority implements IAuthority {
    public description = '';
    public groupId?: number;
    
    constructor(
        public name: string,
    ) {}
}
  